import Axios from 'axios'
import URLS from '../../config/urls'

import router from '../router'

//1、使用自定义配置新建一个 axios 实例
const instance = Axios.create({
  baseURL: URLS.API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});
instance.defaults.retry = 2; //重试2次
instance.defaults.timeout = 60000; //默认超时时间

/*
    如果超时小于1S的话，会出现并发请求导致响应速度慢，调整大一点
*/

function judageTimeZone() {
  var d1 = new Date(2020,0,1);
  var d2 = new Date( 2020, 0,1);
  if (d1.getTimezoneOffset() != d2.getTimezoneOffset()){
    return true
  } else {
    return false
  }
}

function getTimestamp(){
  if (judageTimeZone()){ //utc时间
    return Math.floor((new Date()).getTime() / 1000)
  } else {
    return Date.parse(new Date()) / 1000; //1545816456780  精确到秒级

  }
}

//2、添加请求拦截器
instance.interceptors.request.use(
  config => {
    //发送请求前添加认证token
    // config.headers.Authorization = sessionStorage.getItem('token')
    //console.log(localStorage.getItem("token"),"AASDFSDf")
    config.headers.Authorization = localStorage.getItem('token');
    config.headers.Timestamp = getTimestamp(); //时间戳校验
    config.headers.Ttl = instance.defaults.timeout; //请求生命周期
    config.headers.Service = "order";
    return config
  },
  err => {
    return Promise.reject(err)
  });

//3、添加响应拦截器
instance.interceptors.response.use(function (response) {
  // 对响应数据处理

  if (response.status === 200 || response.status === 201 || response.status === 400) {
    const data = response.data
    if (data.code === 200 || data.code === 201) {
      return data
    }
  }
  return Promise.reject(response)
}, function (error) {
  // console.log(error.code);

  switch (error.code){
    case "ECONNABORTED":
      var config = error.config;

      config.__retryCount = config.__retryCount || 0; //设置重试初始变量

      if (config.__retryCount >= config.retry){
        error.desc = "接口请求超时" +  instance.defaults.timeout + "ms";
        return Promise.reject(error)
      }
      config.__retryCount += 1;
      console.log("响应超时" + instance.defaults.timeout + "ms 自动重试第 " + config.__retryCount + "次 总共重试: " + instance.defaults.retry + "次")
      var backoff = new Promise(function (resolve) {
        setTimeout(function () {
          resolve();
        },1000); //1秒钟重试一次
      });
      return backoff.then(function () {
        return instance(config)
      })


  }

  if (error.response) {
    switch (error.response.status) {
      case 400:
        return Promise.reject(error.response.data)
      case 401:
        // if (router.to.path  === "123") {
        //   alert("123123")
        // }
        window.location.href = '/login'
    }
  }

  // const errorData = error.response.data
  // if (errorData.code === 400) {
  //   return Promise.reject(errorData.desc)
  // }
  // return Promise.reject(errorData)
})



// export const getNodegroups = params => { return instance.get(`${base}/nodegroup/v1/nodegroups/list/`, params).then(res => res.data) }
// export const getNodegroups = params => { return instance.get(`/nodegroup/v1/nodegroups/list/`, params).then(res => res) }

export default instance



// WEBPACK FOOTER //
// ./src/api/ajax.js